/**
 * Read a cookie by name from document.cookie.
 * @param {string} name
 * @returns {string|null}
 */
export function getCookie(name) {
    if (typeof document === 'undefined') return null;
    const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Matches CodeIgniter: last two dot-separated numeric parts from _ga → client ID.
 * @param {string|null} gaCookie
 */
export function parseGaClientId(gaCookie) {
    if (!gaCookie || typeof gaCookie !== 'string') return '';
    const m = gaCookie.trim().match(/(\d+\.\d+)$/);
    return m ? m[1] : '';
}

/**
 * Legacy GA property cookie GS2/GS2.1 parsing — aligns with preg_match('/s(\d+)\$/', ...).
 * @param {string|null} value
 */
export function parseGs2SessionSuffix(value) {
    if (!value || typeof value !== 'string') return '';
    const m = value.match(/s(\d+)\$/);
    return m ? m[1] : '';
}
